import { Injectable } from '@angular/core';
import { Headers, Http, Response, RequestOptions } from '@angular/http';
import {apiUrl}  from './global';
import 'rxjs/add/operator/toPromise';

import { ResponseApi } from './response-api';

@Injectable()
export class Break3Service {
  private url = apiUrl;  // URL to web api

  constructor(private http: Http) { }

  getUrl(url: string): Promise<ResponseApi[]> {
    return this.http
      .get(this.url + 'campaign-url-hash/' + url + '/' + localStorage.getItem('hash'))
      .toPromise()
      .then(response => response.json() as ResponseApi[])
      .catch(this.handleError);
  }

  postAuthenticate(url: string, username:string): Promise<ResponseApi[]> {
    let body = JSON.stringify({ url:url, username: username});
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers , withCredentials: true});
    return this.http
      .post(this.url + 'authenticate-user', body, options)
      .toPromise()
      .then(response => response.json() as ResponseApi[])
      .catch(this.handleError);
  }
  updateAnswer(questionId: number, answerId: number, rate: string): Promise<ResponseApi[]>{
    return this.http
      .get(this.url + 'add-answer/' + questionId + '/' + answerId + '/' + rate + '/' + localStorage.getItem('hash'))
      .toPromise()
      .then(response => response.json() as ResponseApi[])
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }
}



// WEBPACK FOOTER //
// /Users/mosheborochov/Desktop/work/QCEV/dev/QCEV-FRONT/src/app/break3.service.ts